export const ZendeskLogo = ({ height = 24 }: { height?: number }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      viewBox="16 0 48 32"
      fill="currentColor"
      role="img"
      aria-label="Zendesk"
      className="sc-3d47ca59-0 jjdCTY"
    >
      <path d="M37.5 8.8v24.4H17.4zm0-8.8c0 5.6-4.5 10.1-10.1 10.1s-10-4.5-10-10.1zm3.3 33.1c0-5.6 4.5-10.1 10.1-10.1S61 27.5 61 33.1zm0-8.7V0H61z"></path>
    </svg>
  );
};
